import { Youtube, Instagram, Facebook } from 'lucide-react';

const TikTokIcon = (props) => (
  <svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor" aria-hidden="true" {...props}>
    <path d="M21 8.5a7.1 7.1 0 0 1-4.3-1.4v7.6a5.8 5.8 0 1 1-5.8-5.8c.3 0 .6 0 .9.1v3a2.9 2.9 0 1 0 2 2.7V2h2.9a4.3 4.3 0 0 0 4.3 4.3v2.2z" />
  </svg>
);

export const SocialIcons = ({ config, className = '' }) => {
  if (!config) return null;
  const items = [
    { url: config.social_youtube, label: 'YouTube', Icon: Youtube, key: 'youtube' },
    { url: config.social_instagram, label: 'Instagram', Icon: Instagram, key: 'instagram' },
    { url: config.social_tiktok, label: 'TikTok', Icon: TikTokIcon, key: 'tiktok' },
    { url: config.social_facebook, label: 'Facebook', Icon: Facebook, key: 'facebook' },
  ].filter((x) => Boolean(x.url));
  if (items.length === 0) return null;
  return (
    <ul className={`flex items-center gap-2 ${className}`}>
      {items.map(({ url, label, Icon, key }) => (
        <li key={key}>
          <a
            href={url}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={label}
            data-testid={`social-${key}-link`}
            className="inline-flex h-10 w-10 items-center justify-center rounded-full border border-[hsl(var(--border))] bg-[hsl(var(--card))] text-[hsl(var(--foreground))] transition-colors hover:bg-[hsl(var(--accent)/0.35)]"
          >
            <Icon size={18} strokeWidth={1.75} />
          </a>
        </li>
      ))}
    </ul>
  );
};
